import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { fetchUsers } from '../action/user';
import {accountingPages} from '../constants/page';
import {Route, Redirect} from 'react-router-dom';

class AccountingPage extends Component {
    render() {
        return (
            <Fragment>
                {
                    accountingPages.map(page => {
                        return (
                            <Route
                                key={page.name}
                                exact
                                path={page.path}
                                render={props => {
                                    if (page.access && !page.access.includes(this.props.auth.role.id)) {
                                        return <Redirect to="/"/>
                                    }

                                    if (props.match.params.id && !/\d+/.test(props.match.params.id)) {
                                        return null;
                                    }

                                    const Component = page.component;
                                    return (
                                            <Component {...props}/>
                                    );
                                }}
                            />
                        );
                    })
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    users: state.users.list,
    loading: state.loaders.content,
    auth: state.user.info
});

const mapDispatchToProps = {
    fetchUsers: () => fetchUsers()
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingPage);